<script setup>
import { computed } from 'vue';
import _ from 'lodash'
import IconCheckmark from '../../components/icon/IconCheckmark.vue';
import IconBase from '../../components/icon/IconBase.vue';

const props = defineProps({
  data: {
    type: Object,
  }
})

const content = computed(() => {
  if (props.data === false) return ''
  return props.data
})

const showCheckBeforeText = computed(() => {
  if (typeof props.data !== 'string') return false
  const s = props.data.trim()
  return s === 'Included at no extra cost' || s === 'Available as add-ons'
})
</script>

<template>
  <div class="p-2 min-h-10 h-12 lg:h-auto flex items-center justify-center">
    <figure v-if="props.data === true" class="bg-success mx-auto flex items-center justify-center size-4 rounded-full">
      <IconBase classIcon="text-white" width="12px" height="12px">
        <IconCheckmark />
      </IconBase>
    </figure>
    <div v-else-if="content && showCheckBeforeText" class="flex items-center justify-center gap-x-2">
      <div class="text-center leading-none">
        <figure class="bg-success shrink-0 inline-flex items-center justify-center size-4 rounded-full mr-px">
          <IconBase classIcon="text-white" width="12px" height="12px">
            <IconCheckmark />
          </IconBase>
        </figure>
        {{ content }}
      </div>
    </div>
    <p class="text-center leading-none" v-else-if="content" v-html="content" />
  </div>
</template>

<style></style>
